<template lang="pug">
    progress-bar(
      @input="dispatch"
      @simulate="dispatch"
      @ghost="dispatch"
      :progressColor="progressColor"
      :thumbColor="thumbColor"
      :highlightColor="highlightColor"
      :duration="duration"
      :time="playtime"
      :ghost="ghost"
      :buffer="buffer"
      :chapters="getChapters()"
      :quantiles="quantiles"
      :large="large"
      :title="$t('A11Y.PROGRESSBAR_INPUT')"
      data-test="progress-bar"
      :hideProgressThumb="!extendedBlock"
    )
</template>

<script>
import { mapState } from 'redux-vuex';
import color from 'color';
import { ProgressBar } from '@/components/shared-components';

import store from '@/store';
import select from '@/store/selectors';

export default {
  components: {
    ProgressBar,
  },
  data: mapState({
    progressColor: select.theme.brandDark,
    duration: select.duration,
    playtime: select.playtime,
    ghost: select.ghost.time,
    buffer: select.network.buffer,
    extendedBlock: select.components.extendedBlock,
    chapters: select.chapters.list,
    quantiles: select.quantiles,
    darkMode: select.customOptions.darkMode,
  }),
  computed: {
    highlightColor() {
      return this.darkMode ? '#FFFFFF' : '#000000';
    },

    thumbColor() {
      return this.darkMode ? '#FFFFFF' : '#000000';
    },
  },
  props: {
    large: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    dispatch: store.dispatch,
    color,
    getChapters() {
      return this.chapters;
    },
  },
};
</script>
